import DownloadIcon from '@mui/icons-material/Download';
import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { InventoryListDetails } from './components/InventoryLists/InventoryListDetails/InventoryListDetails';
import { downloadInventoryList } from './utils/downloadInventoryList/downloadInventoryList';

export const InventoryListDetailsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { inventoryListId } = useParams<{ inventoryListId: string }>();
  const { useInventoryListByIdFetch, useDeleteInventoryList } = useAdministrationContext();
  const { deleteInventoryList, loading: deleteLoading } = useDeleteInventoryList();
  const { loading, inventoryList } = useInventoryListByIdFetch(inventoryListId);

  if (loading || !inventoryList) {
    return <Loader />;
  }

  return (
    <PageHeader
      title={t('Details: {name}', { name: inventoryList?.name })}
      goBack={() => {
        navigate('/inventory-lists');
      }}
      render={() => (
        <HeaderActions
          actions={[
            {
              label: t('Edit'),
              onClick: () => {
                navigate(`/inventory-lists/${inventoryListId}/edit`);
              },
              color: 'default',
              isAllowed: true,
              showAsActionButton: true,
              'data-test': 'edit',
            },
            {
              label: t('Delete'),
              onClick: () => deleteInventoryList({ name: inventoryList.name, id: inventoryList.id }),
              color: 'error',
              isAllowed: true,
              loading: deleteLoading,
              showAsActionButton: true,
              'data-test': 'delete',
            },
            {
              label: 'divider',
              color: 'default',
              showAsActionButton: true,
              showAsDivider: true,
            },
            {
              color: 'default',
              'data-test': 'download-button',
              onClick: () => downloadInventoryList(inventoryList),
              isAllowed: true,
              label: t('Download'),
              showAsActionButton: true,
              endIcon: <DownloadIcon />,
            },
          ]}
        />
      )}
      titlePrefix={'OpenXSelect'}
    >
      <InventoryListDetails inventoryList={inventoryList} />
    </PageHeader>
  );
};
